import { render, staticRenderFns } from "./ProfileImageBox.vue?vue&type=template&id=4ee6ac81&"
import script from "./ProfileImageBox.vue?vue&type=script&lang=ts&"
export * from "./ProfileImageBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports